import { render, staticRenderFns } from "./batch-send.vue?vue&type=template&id=31be948e&scoped=true"
import script from "./batch-send.vue?vue&type=script&lang=js"
export * from "./batch-send.vue?vue&type=script&lang=js"
import style0 from "./batch-send.vue?vue&type=style&index=0&id=31be948e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be948e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31be948e')) {
      api.createRecord('31be948e', component.options)
    } else {
      api.reload('31be948e', component.options)
    }
    module.hot.accept("./batch-send.vue?vue&type=template&id=31be948e&scoped=true", function () {
      api.rerender('31be948e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/components/batch-send.vue"
export default component.exports